"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@mui/styles");

var _BuilderThemeProvider = require("../BuilderThemeProvider");

var _StepIcon = _interopRequireDefault(require("./StepIcon"));

var _StepConnector = _interopRequireDefault(require("./StepConnector"));

var _StepLabel = _interopRequireDefault(require("./StepLabel"));

var StyledStep = (0, _styles.withStyles)(function () {
  return (0, _styles.createStyles)({
    root: {}
  });
})(_material.Step);
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette,
      zIndex = _ref.zIndex;
  return {
    baseStepper: {
      padding: spacing(2.5, 2.5, 1.75, 2.5),
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: zIndex.appBar
    },
    chambray_Stepper: {
      backgroundColor: palette.primary.light,
      boxShadow: "0 2px 2px 0 ".concat(palette.primary.main)
    },
    california_Stepper: {
      backgroundColor: palette.orange.light,
      boxShadow: "0 2px 2px 0 ".concat(palette.orange.main)
    },
    red_Stepper: {
      backgroundColor: palette.additional.red80,
      boxShadow: "0 2px 2px 0 ".concat(palette.additional.red80)
    },
    green_Stepper: {
      backgroundColor: palette.green.fruitSalad80,
      boxShadow: "0 2px 2px 0 ".concat(palette.green.fruitSalad80)
    }
  };
});

var BuilderStepper = function BuilderStepper(_ref2) {
  var _steps$activeStepIdx;

  var activeStep = _ref2.activeStep,
      onChangeActiveStep = _ref2.onChangeActiveStep,
      children = _ref2.children,
      _ref2$theme = _ref2.theme,
      propsTheme = _ref2$theme === void 0 ? 'chambray' : _ref2$theme,
      muiStepperProps = (0, _objectWithoutProperties2.default)(_ref2, ["activeStep", "onChangeActiveStep", "children", "theme"]);
  var classes = useStyles();

  var _useBuilderTheme = (0, _BuilderThemeProvider.useBuilderTheme)(),
      _useBuilderTheme$them = _useBuilderTheme.theme,
      theme = _useBuilderTheme$them === void 0 ? propsTheme : _useBuilderTheme$them;

  var steps = (0, _react.useMemo)(function () {
    return children.map(function (element) {
      return {
        label: element.props.label,
        name: element.props.name,
        children: element
      };
    });
  }, [children]);
  var activeStepIdx = (0, _react.useMemo)(function () {
    return steps.findIndex(function (step) {
      return step.name === activeStep;
    });
  }, [steps, activeStep]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    height: 82,
    flex: "0 0 82px"
  }, /*#__PURE__*/_react.default.createElement(_material.Stepper, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.baseStepper, classes["".concat(theme, "_Stepper")]),
    activeStep: activeStepIdx,
    alternativeLabel: true,
    connector: /*#__PURE__*/_react.default.createElement(_StepConnector.default, null)
  }, muiStepperProps), steps.map(function (step) {
    return /*#__PURE__*/_react.default.createElement(StyledStep, {
      key: step.name
    }, /*#__PURE__*/_react.default.createElement(_StepLabel.default, {
      StepIconComponent: _StepIcon.default,
      StepIconProps: {
        onClick: onChangeActiveStep ? function () {
          return onChangeActiveStep(step.name);
        } : undefined
      }
    }, step.label));
  }))), (_steps$activeStepIdx = steps[activeStepIdx]) === null || _steps$activeStepIdx === void 0 ? void 0 : _steps$activeStepIdx.children);
};

var _default = BuilderStepper;
exports.default = _default;